import { Outlet } from 'react-router-dom';
import Header from './Header';
import MobileNavigation from './MobileNavigation';
import CitySelector from '../city/CitySelector';
import styles from './MainLayout.module.css';
import AddToHomeScreen from '../common/AddToHomeScreen';
import BetaMessageBanner from '../common/BetaMessageBanner'; // Import the new component
import WorkInProgressPopup from '../common/WorkInProgressPopup';
import VideoIntroPopup from '../common/VideoIntroPopup';
import { useState, useCallback, useEffect } from 'react';

function MainLayout() {
  const [videoDone, setVideoDone] = useState(false);

  const handleVideoFinished = useCallback(() => {
    setVideoDone(true);
  }, []);

  // Mobilde header yüksekliğine göre üst padding uygula
  useEffect(() => {
    const applyHeaderOffset = () => {
      const header = document.querySelector('header');
      if (header) {
        const h = Math.round(header.getBoundingClientRect().height);
        document.documentElement.style.setProperty('--header-mobile-height', h + 'px');
      }
    };
    applyHeaderOffset();
    window.addEventListener('resize', applyHeaderOffset);
    return () => window.removeEventListener('resize', applyHeaderOffset);
  }, []);

  return (
    <>
      <BetaMessageBanner />
      <div className={styles.layoutContainer}>
        <Header />
        <main className={styles.mainContent}>
          <Outlet />
        </main>
        <MobileNavigation />
        <CitySelector />
        <AddToHomeScreen />
        {/* Video açılış pop-up'ı: kapanınca diğer popup açılmasına izin ver */}
        {!videoDone && (
          <VideoIntroPopup onClose={handleVideoFinished} />
        )}
        {/* Video bitmeden WorkInProgress görünmez; video bitince forceShow ile anında açılır */}
        {videoDone && <WorkInProgressPopup forceShow />}
      </div>
    </>
  );
}

export default MainLayout;
